import type { CityConfig } from "../city-template/types";

export const olympiaConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from Washington Department of Health in Tumwater. Online, mail, or in-person at 101 Israel Rd SE, Tumwater WA 98501.",
      url: "https://doh.wa.gov/licenses-permits-and-certificates/vital-records",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Washington DOH Vital Records. Available online and by mail for estate and legal matters.",
      url: "https://doh.wa.gov/licenses-permits-and-certificates/vital-records",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage licenses from the Thurston County Auditor at 2000 Lakeridge Dr SW in Olympia. Certified copies for passport name changes.",
      url: "https://www.thurstoncountywa.gov/auditor",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through Thurston County Superior Court. Required for name change passport corrections.",
      url: "https://www.thurstoncountywa.gov/superior-court",
    },
  ],
  city: "Olympia",
  state: "Washington",
  stateAbbr: "WA",
  slug: "olympia",
  route: "/cities/olympia",
  title: "Emergency Passport Olympia, WA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Olympia, WA — as fast as 24 hours. Fast passport renewal and new passport applications for Olympia, Lacey, Tumwater, and all Thurston County residents. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Olympia, Washington",
  heroSubtitle: "Olympia travelers — from state government employees to Evergreen State College students to Thurston County families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving Washington's capital city and all of South Sound.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Olympia%20Washington%20state%20capitol%20building%20with%20iconic%20white%20dome%2C%20lush%20green%20Capitol%20Campus%20grounds%20overlooking%20Budd%20Inlet%20and%20Puget%20Sound%2C%20downtown%20Olympia%20with%20historic%20buildings%20and%20tree-lined%20streets%2C%20Mount%20Rainier%20visible%20on%20clear%20day%20in%20distant%20background%2C%20warm%20golden%20afternoon%20light%2C%20Pacific%20Northwest%20capital%20city%20atmosphere%2C%20professional%20landscape%20photography%20without%20text%20or%20people&width=1800&height=700&seq=olympia-hero-001&orientation=landscape",
  heroImageAlt: "Olympia Washington state capitol building and Capitol Campus with Budd Inlet",
  geoPosition: "47.0379;-122.9007",
  geoPlacename: "Olympia, Washington",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "Approximately 60 miles, 1 hour via I-5",
  },
  nearbyCitiesZips: [
    { name: "Olympia", zips: "98501, 98502, 98504, 98506, 98507, 98508, 98509, 98511, 98512, 98513, 98516, 98599" },
    { name: "Lacey", zips: "98503, 98509, 98516" },
    { name: "Tumwater", zips: "98501, 98511, 98512" },
    { name: "Yelm", zips: "98597" },
    { name: "Rainier", zips: "98576" },
    { name: "Tenino", zips: "98589" },
    { name: "Rochester", zips: "98579" },
    { name: "Shelton", zips: "98584" },
    { name: "Centralia", zips: "98531" },
    { name: "Chehalis", zips: "98532" },
    { name: "Bucoda", zips: "98530" },
    { name: "Rochester", zips: "98579" },
    { name: "Dupont", zips: "98327" },
    { name: "Steilacoom", zips: "98388" },
    { name: "University Place", zips: "98464, 98466, 98467" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Seattle Passport Agency — just 60 minutes up I-5, but we save you the trip" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Capital City Hub", desc: "Serving state government employees, Evergreen students, and South Sound professionals" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any Thurston County location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Seattle, WA", route: "/cities/seattle" },
    { name: "Emergency passport help in Tacoma, WA", route: "/cities/tacoma" },
    { name: "Urgent passport services in Bellevue, WA", route: "/cities/bellevue" },
    { name: "Washington passport services overview", route: "/washington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Olympia, Washington remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — approximately 60 miles north via I-5. Olympia residents can ship from any UPS or FedEx in Thurston County.",
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeDistance: "Serving Olympia, Lacey, Tumwater, Yelm, and all of Thurston County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Olympia and Thurston County. From the Capitol Campus overlooking Budd Inlet to downtown Olympia, from Lacey and Tumwater to the rural South Sound communities — we serve all of Washington's capital region.",
  nearbyCitiesIntro: "We serve Olympia and all nearby communities including Lacey, Tumwater, Yelm, Rainier, Tenino, Rochester, Shelton, Centralia, and Chehalis. Our courier service reaches all of Thurston, Mason, and Lewis counties.",
  howItWorksIntro: "Most Olympia travelers complete everything online and ship documents overnight. No need to drive 60 minutes north on I-5 to Seattle — our couriers handle the agency delivery and always pick the fastest route.",
  mistakesIntro: "Olympia is Washington's state capital with thousands of government employees, Evergreen State College, and significant international travel demand. Here are the most common passport mistakes we see from South Sound travelers.",
  testimonialsIntro: "Olympia travelers — from state agency directors to Evergreen students to Thurston County families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Olympia, WA? Here are the most common ones we hear from South Sound travelers.",
  statePageRoute: "/states/washington",
  statePageName: "Washington",
  dmvWebsite: "https://www.dol.wa.gov",
  dmvLabel: "Washington DOL — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — 60 min via I-5, courier handles it", "No I-5 drive or downtown Seattle parking hassle", "Perfect for state employees and Evergreen students", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — courier handles everything", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 60 minutes to Seattle via I-5", "Downtown Seattle parking and traffic"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Olympia travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Seattle Passport Agency just 60 miles north via I-5.",
      bullets: ["24–48 hour turnaround available", "Seattle Passport Agency — courier handles the drive", "State employee and student travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Olympia adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Thurston County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Olympia residents — including state employees, Evergreen students, and Thurston County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Olympia residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Olympia and Thurston County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Olympia and Thurston County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Olympia WA", description: "Urgent passport processing for Olympia Washington travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Olympia WA", description: "Fast passport renewal for Olympia Washington residents with a previously-issued passport." },
    { name: "First-Time Passport Olympia WA", description: "New passport application services for Olympia Washington residents applying for their first passport." },
    { name: "Child Passport Olympia WA", description: "Minor passport services for Olympia Washington families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jennifer M.",
      location: "Olympia, WA",
      rating: 5,
      text: "State agency sent me to an international conference with 7 days notice. My passport had expired. Fast Passport Center had it renewed in 3 days. Shipped from the UPS Store on Capitol Way and never worried once.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "David R.",
      location: "Lacey, WA",
      rating: 5,
      text: "Family trip to London with 6 days notice. Four passports total — two adult renewals and two first-time for our kids. Done in 4 days. Smooth from start to finish.",
      service: "Family Passport Bundle",
    },
    {
      name: "Rachel T.",
      location: "Tumwater, WA",
      rating: 5,
      text: "Evergreen semester abroad program in Costa Rica. Realized my passport was damaged 2 weeks before departure. Fast Passport Center replaced it in 5 days. Incredible service for college students.",
      service: "Damaged Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "oly-1",
      name: "Olympia Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "900 Jefferson St SE",
      city: "Olympia",
      state: "WA",
      zip: "98501",
      phone: "(360) 753-7669",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Olympia, near the Capitol Campus",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Olympia acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to state employees and downtown residents.",
      icon: "ri-mail-line",
    },
    {
      id: "oly-2",
      name: "Lacey Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5815 Lacey Blvd SE",
      city: "Lacey",
      state: "WA",
      zip: "98503",
      phone: "(360) 456-9627",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lacey, approximately 5 miles east of downtown Olympia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Lacey and east Thurston County residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "oly-3",
      name: "Tumwater Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 Israel Rd SE",
      city: "Tumwater",
      state: "WA",
      zip: "98501",
      phone: "(360) 943-7646",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Tumwater, approximately 3 miles south of downtown Olympia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Tumwater and south Thurston County. Good alternative for south-side residents.",
      icon: "ri-mail-line",
    },
    {
      id: "oly-4",
      name: "Thurston County Auditor",
      type: "County Auditor Passport Acceptance",
      address: "2000 Lakeridge Dr SW, Bldg 1",
      city: "Olympia",
      state: "WA",
      zip: "98502",
      phone: "(360) 786-5404",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "West Olympia, Thurston County Courthouse Complex",
      website: "https://www.thurstoncountywa.gov/auditor",
      websiteLabel: "Thurston County Auditor",
      notes: "County Auditor passport acceptance. Extended hours compared to post office. Convenient to west Olympia. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 60 miles via I-5 to Seattle", fpc: "No — ship from Olympia" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "South Sound Advantage", agency: "No special consideration", fpc: "Yes — courier handles the I-5 trip" },
    { feature: "Government Shutdowns", agency: "Operations may be impacted", fpc: "Not affected by government shutdowns" },
    { feature: "Total Time Commitment", agency: "Half day driving + waiting at agency", fpc: "10 minutes online + overnight shipping" },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Waiting Until the Last Minute", description: "Olympia state employees and students often discover passport issues just before conferences or study abroad. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip." },
    { icon: "ri-image-line", title: "Wrong Passport Photo", description: "Local photo services in Olympia and Lacey sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background." },
    { icon: "ri-file-list-line", title: "Incomplete DS-11 Form", description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Thurston County acceptance facilities." },
    { icon: "ri-map-pin-2-line", title: "Not Booking Acceptance Facilities Early Enough", description: "Olympia Post Office appointments fill during legislative session and summer travel peaks. Book 2–3 weeks ahead." },
    { icon: "ri-time-line", title: "Assuming 4–6 Weeks Is Enough", description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. State employee travel and legislative recesses create seasonal demand — plan ahead." },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Olympia or Thurston County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Olympia, Lacey, or Tumwater." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Seattle Passport Agency — handling the I-5 drive for you." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Olympia address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Olympia, WA?", a: "Fast Passport Center offers emergency passport processing in Olympia, Washington in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — approximately 60 miles north via I-5." },
    { q: "Does Olympia have its own passport agency?", a: "No — Olympia does not have a regional passport agency despite being Washington's state capital. The nearest facility is the Seattle Passport Agency (approximately 60 miles north via I-5). Fast Passport Center's courier service means Olympia residents never need to make that drive." },
    { q: "Can I get an expedited passport in Lacey or Tumwater?", a: "Absolutely. Fast Passport Center serves all of Thurston County including Lacey, Tumwater, Yelm, Rainier, and Tenino. Our service works the same way everywhere in South Sound." },
    { q: "What airport do Olympia travelers use for international flights?", a: "Seattle-Tacoma International Airport (SEA) is the primary international gateway — approximately 50 miles north via I-5. Olympia Regional Airport (OLM) serves general aviation and limited commercial flights. Most international travel connects through SEA." },
    { q: "Does Fast Passport Center serve Washington state government employees?", a: "Yes. Fast Passport Center serves all of Olympia including Washington state government employees, legislators, and agency staff. We understand the demands of official travel and can accommodate urgent passports for international conferences and official duties." },
    { q: "How much does an expedited passport cost in Olympia, WA?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Olympia?", a: "Walgreens, CVS, and Rite Aid stores throughout Olympia and Lacey offer passport photos. UPS Store and FedEx Office locations also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Evergreen State College students?", a: "Yes. Fast Passport Center serves all of Thurston County including Evergreen State College students and faculty. We understand academic program deadlines and study abroad requirements. Our courier service is ideal for students who can't take a day off to drive to Seattle." },
  ],
  photoLocations: [
    { name: "Walgreens — Capitol Way", address: "3510 Capitol Way SE, Olympia, WA 98501", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS — Cooper Point Rd", address: "2410 Harrison Ave NW, Olympia, WA 98502", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Downtown Olympia", address: "111 Capitol Way N, Olympia, WA 98501", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Lacey", address: "5815 Lacey Blvd SE, Lacey, WA 98503", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "WA DOL — Olympia", address: "2000 4th Ave W, Olympia, WA 98502", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Washington Department of Licensing for driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended.", featured: true },
    { name: "WA DOL — Lacey", address: "1000 College St SE, Lacey, WA 98503", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Lacey and eastside communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "Approximately 50 miles north of Olympia via I-5",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "Primary international airport for Olympia and South Sound travelers. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines hub.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Flight Info",
      featured: true,
    },
    {
      code: "OLM",
      name: "Olympia Regional Airport",
      distance: "5 miles south of downtown Olympia",
      address: "7608 Old Hwy 99 SE, Olympia, WA 98501",
      note: "General aviation and limited commercial service. Most Olympia travelers connect through SEA for international flights.",
      flightUrl: "https://www.olympiawa.gov/",
      flightLabel: "OLM Airport Info",
      featured: false,
    },
  ],
};